import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const authHeaders = (token) => {
  const authToken = token || null;
  return authToken
    ? {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "application/json",
      }
    : { "Content-Type": "application/json" };
};

export async function getClientReviewContext(token) {
  const res = await axios.get(`${API}/client-reviews/public/context`, {
    params: { token },
  });
  return res.data;
}

export async function submitClientReview(token, payload) {
  const res = await axios.post(
    `${API}/client-reviews/public/submit`,
    payload,
    { params: { token } }
  );
  return res.data;
}

export async function getTicketReview(ticketId) {
  const res = await axios.get(`${API}/tickets/${ticketId}/review`, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function resendClientReview(reviewId) {
  const res = await axios.post(
    `${API}/client-reviews/${reviewId}/resend`,
    {},
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}

export async function resendTicketClientReview(ticketId) {
  const res = await axios.post(
    `${API}/tickets/${ticketId}/review/resend`,
    {},
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}

export async function getClientServiceLogReviews(clientId, params = {}) {
  const res = await axios.get(`${API}/clients/${clientId}/service-log/reviews`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientSatisfactionSummary(params) {
  const res = await axios.get(`${API}/reports/client-satisfaction/summary`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientSatisfactionDashboard(params) {
  const res = await axios.get(`${API}/reports/client-satisfaction/dashboard`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientSatisfactionTechnicianKpi(params) {
  const res = await axios.get(`${API}/reports/client-satisfaction/technician-kpi`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientSatisfactionTechnicians(params) {
  const res = await axios.get(`${API}/reports/client-satisfaction/technicians`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientSatisfactionTrends(params) {
  const res = await axios.get(`${API}/reports/client-satisfaction/trends`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getClientSatisfactionInsights(payload) {
  const res = await axios.post(
    `${API}/reports/client-satisfaction/insights`,
    payload,
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}

export async function getFeedbackThemesReport(payload) {
  const res = await axios.post(`${API}/reports/feedback-themes`, payload, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function getReviewFollowups(params = {}) {
  const res = await axios.get(`${API}/review-followups`, {
    params,
    headers: authHeaders(),
  });
  return res.data;
}

export async function getReviewFollowup(followupId) {
  const res = await axios.get(`${API}/review-followups/${followupId}`, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function updateReviewFollowup(followupId, payload) {
  const res = await axios.put(`${API}/review-followups/${followupId}`, payload, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function addReviewFollowupNote(followupId, payload) {
  const res = await axios.post(
    `${API}/review-followups/${followupId}/notes`,
    payload,
    {
      headers: authHeaders(),
    }
  );
  return res.data;
}
